<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style4', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbar />
    </div>
    <MainBanner />
    <BestServices />
    <AboutUs />
    <BookAnAppointment />
    <OurDepartment />
    <OurDoctors />
    <GalleryExhibition />
    <OurPricing />
    <OurTestimonials />
    <SeeSamples />
    <TouchWithUs />
    <LatestNews />
    <MainFooter />
  </div>
</template>

<script lang="ts">
import TopHeader from "../Layouts/TopHeader.vue";
import MainNavbar from "../Layouts/MainNavbar.vue";
import MainBanner from "../HomeSix/MainBanner.vue";
import BestServices from "../HomeSix/BestServices.vue";
import AboutUs from "../HomeSix/AboutUs.vue";
import BookAnAppointment from "../HomeSix/BookAnAppointment.vue";
import OurDepartment from "../HomeSix/OurDepartment.vue";
import OurDoctors from "../HomeSix/OurDoctors.vue";
import GalleryExhibition from "../HomeSix/GalleryExhibition.vue";
import OurPricing from "../HomeSix/OurPricing.vue";
import OurTestimonials from "../HomeSix/OurTestimonials.vue";
import SeeSamples from "../HomeSix/SeeSamples.vue";
import TouchWithUs from "../HomeSix/TouchWithUs.vue";
import LatestNews from "../HomeSix/LatestNews.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeSixPage",
  components: {
    TopHeader,
    MainNavbar,
    MainBanner,
    BestServices,
    AboutUs,
    BookAnAppointment,
    OurDepartment,
    OurDoctors,
    GalleryExhibition,
    OurPricing,
    OurTestimonials,
    SeeSamples,
    TouchWithUs,
    LatestNews,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      this.isSticky = scrollPos >= 100;
    });
  },
});
</script>